import { Button, InputField } from "@myloc/myloc-gui";
import PropType from "prop-types";
import { useEffect, useState } from "react";
import { useTranslate } from "../../../language/i18n";
import { setError } from "../../../reducers/dialog/dialogAction";
import Label from "../../shared/Label/Label";
import styles from "../ReceiveDeliveryOrderPage.module.scss";

const ReceiveProduct = ({
  data,
  addData,
  batchNr = false,
  serialNr = false,
  useManufacturingDate = false,
  setCurrentStep,
  nextStep,
}) => {
  const translate = useTranslate();
  const [batch, setBatch] = useState("");
  const [serialNumber, setSerialNumber] = useState("");
  const [manufacturingDate, setManufacturingDate] = useState("");
  const [manufacturer, setManufacturer] = useState("");

  useEffect(() => {
    if (data?.batchNr) {
      setBatch(data?.batchNr);
    }
    if (data?.serialNr) {
      setSerialNumber(data?.serialNr);
    }
    if (data?.manufacturer) {
      setManufacturer(data?.manufacturer);
    }
    if (data?.manufacturingDate) {
      setManufacturingDate(data?.manufacturingDate);
    }
  }, [data]);

  function goToNextStep() {
    if (batchNr && !data?.batchNr) {
      setError({ error: "exception", errorMessage: translate("BATCH_REQUIRED") });
      return;
    }

    if (serialNr && !data?.serialNr) {
      setError({ error: "exception", errorMessage: translate("SERIAL_NUMBER_REQUIRED") });
      return;
    }

    if (useManufacturingDate && !data?.manufacturer) {
      setError({ error: "exception", errorMessage: translate("MANUFACTURER_REQUIRED") });
      return;
    }

    if (useManufacturingDate && !data?.manufacturingDate) {
      setError({ error: "exception", errorMessage: translate("MANUFACTURING_DATE_REQUIRED") });
      return;
    }

    setCurrentStep(nextStep);
  }

  function canGoToNextStep() {
    if (batchNr && !data?.batchNr) return true;
    if (serialNr && !data?.serialNr) return true;
    if (useManufacturingDate && (!data?.manufacturer || !data?.manufacturingDate)) return true;

    return false;
  }

  return (
    <article className={styles.container}>
      <section className={styles.section}>
        <Label label={translate("PRODUCT_NUMBER_SHORT")} value={data?.product?.productNumber} inline />
        <Label label={translate("SUPPLIER")} value={data?.product?.supplier?.label} inline />
        {data?.amount && <Label label={translate("AMOUNT")} value={data?.amount} inline />}

        <div className={styles.input}>
          {batchNr && (
            <InputField
              label={translate("BATCH_NO") + "*"}
              value={batch}
              onChange={event => addData("batchNr", event.target.value)}
            />
          )}
        </div>
        <div className={styles.input}>
          {serialNr && (
            <InputField
              label={translate("SERIAL_NUMBER_SHORT")}
              value={serialNumber}
              required={serialNr}
              onChange={event => addData("serialNr", event.target.value)}
            />
          )}
        </div>
        <div className={styles.input}>
          {useManufacturingDate && (
            <InputField
              label={translate("MANUFACTURER")}
              value={manufacturer}
              required={useManufacturingDate}
              onChange={event => addData("manufacturer", event.target.value)}
            />
          )}
        </div>
        <div className={styles.input}>
          {useManufacturingDate && (
            <InputField
              type="date"
              label={translate("MANUFACTURING_DATE")}
              labelAlwaysTop={true}
              value={manufacturingDate}
              required={useManufacturingDate}
              onChange={event => addData("manufacturingDate", event.target.value)}
            />
          )}
        </div>
      </section>
      <Button type="submit" disabled={canGoToNextStep()} customCssClass={styles.button} onClick={() => goToNextStep()}>
        {translate("NEXT")}
      </Button>
    </article>
  );
};

ReceiveProduct.propTypes = {
  data: PropType.object,
  addData: PropType.func,
  batchNr: PropType.bool,
  serialNr: PropType.bool,
  useManufacturingDate: PropType.bool,
  setCurrentStep: PropType.func,
  nextStep: PropType.number,
};

export default ReceiveProduct;
